export function extractXmlFromMarkdown(markdown: string): string | null {
  const explicitXml = markdown.match(/```xml\s*\n([\s\S]*?)```/);
  if (explicitXml) return explicitXml[1].trim();

  const fencedRegex = /```(?:\w+)?\s*\n([\s\S]*?)```/g;
  let match;
  while ((match = fencedRegex.exec(markdown)) !== null) {
    const content = match[1].trim();
    if (looksLikeXml(content)) return content;
  }

  const xmlMatch = markdown.match(
    /(<([a-zA-Z][a-zA-Z0-9_-]*)(?:\s[^>]*)?>[\s\S]*?<\/\2>)/,
  );
  if (xmlMatch) return xmlMatch[1].trim();

  return null;
}

export function looksLikeXml(str: string): boolean {
  if (!/^(<\?xml|<[a-zA-Z])/.test(str.trimStart())) return false;
  if (!/<\/[a-zA-Z]/.test(str)) return false;
  return true;
}
